var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 14.0001L25.8528 5.86145C26.0482 5.66608 26.0482 5.34938 25.8528 5.154L22.8462 2.14659C22.7524 2.05278 22.6248 2 22.4925 2C22.3599 2 22.2325 2.05278 22.1387 2.14659L13.9998 10.2855L5.86089 2.14659C5.67327 1.95897 5.34106 1.95897 5.15344 2.14659L2.14653 5.154C1.95116 5.34938 1.95116 5.66608 2.14653 5.86145L10.2852 14.0001L2.14653 22.1388C1.95116 22.3342 1.95116 22.6509 2.14653 22.8462L5.15344 25.8534C5.24725 25.9472 5.37458 26 5.50717 26C5.63975 26 5.76708 25.9472 5.86089 25.8534L13.9998 17.7145L22.1387 25.8534C22.2325 25.9472 22.3599 26 22.4925 26C22.6248 26 22.7524 25.9472 22.8462 25.8534L25.8531 22.8462C26.0485 22.6509 26.0485 22.3339 25.8531 22.1388L17.7144 14.0001Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 14.0001L25.8528 5.86145C26.0482 5.66608 26.0482 5.34938 25.8528 5.154L22.8462 2.14659C22.7524 2.05278 22.6248 2 22.4925 2C22.3599 2 22.2325 2.05278 22.1387 2.14659L13.9998 10.2855L5.86089 2.14659C5.67327 1.95897 5.34106 1.95897 5.15344 2.14659L2.14653 5.154C1.95116 5.34938 1.95116 5.66608 2.14653 5.86145L10.2852 14.0001L2.14653 22.1388C1.95116 22.3342 1.95116 22.6509 2.14653 22.8462L5.15344 25.8534C5.24725 25.9472 5.37458 26 5.50717 26C5.63975 26 5.76708 25.9472 5.86089 25.8534L13.9998 17.7145L22.1387 25.8534C22.2325 25.9472 22.3599 26 22.4925 26C22.6248 26 22.7524 25.9472 22.8462 25.8534L25.8531 22.8462C26.0485 22.6509 26.0485 22.3339 25.8531 22.1388L17.7144 14.0001Z",
    stroke: "#FF441B",
    strokeWidth: 4,
    mask: "url(#path-1-outside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c25f0b75.svg";
export { ForwardRef as ReactComponent };